<template>
    <md-button
        title="Upload Attachments"
        class="md-primary md-just-icon md-round"
        :disabled="disableActionButtons && disableUploadAttachmentButton(blockoutDay)"
        :class="disableActionButtons && disableUploadAttachmentButton(blockoutDay) ? 'md-disabled' : ''"
        @click="handleAddBlockoutDayAttachment(blockoutDay)"
    >
        <md-icon>attach_file</md-icon>
    </md-button>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import BlockoutDayAttachmentModal from './BlockoutDayAttachmentModal';

export default {
    name: 'BlockoutDaysAddAttachmentButton',
    mixins: [GeneralMixin],
    props: {
        blockoutDay: {
            type: Object,
            default: () => {},
            required: true
        },
        disableActionButtons: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleAddBlockoutDayAttachment(blockoutDay) {
            this.$modal.show(BlockoutDayAttachmentModal).then(({ imageList, documentList }) => {
                this.handleImageListUpdate(imageList);
                this.handleDocumentListUpdate(documentList);

                if (!blockoutDay.inAddMode && !blockoutDay.inEditMode) {
                    this.$emit('saveBlockoutDay', { blockoutDay, addMode: false });
                }
            });
        },
        disableUploadAttachmentButton(blockoutDay) {
            return !blockoutDay.inAddMode && !blockoutDay.inEditMode;
        },
        handleImageListUpdate(imageList) {
            this.$emit('imageListUpdate', imageList);
        },
        handleDocumentListUpdate(documentList) {
            this.$emit('documentListUpdate', documentList);
        }
    }
};
</script>
